
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator'
import FlagSelect from "@/components/common/FlagSelect.vue";
import {f2mServicesSlugs} from "@/constants/f2mSlugs";
import {getSlug} from "@/router";

@Component({
    components: {FlagSelect}
})
export default class Header extends Vue {
    @Prop() readonly user!: any;
    get f2mKeys() {
        return Object.keys(f2mServicesSlugs).filter(key => this.getF2mServiceLink(key));
    }
    getF2mServiceLink (f2mKey: string) {
        return f2mServicesSlugs[f2mKey][`${this.$language}-${this.$country}`] || f2mServicesSlugs[f2mKey][this.$language] || f2mServicesSlugs[f2mKey]['*'];
    }

    flagSelected(country: string) {
        const slug = getSlug(country.split('-')[0], country.split('-')[1], this.$route.name);
        window.location.href = `${this.$appBaseUrl}/${country}/${slug}`;
    }
}
